module.exports = __webpack_public_path__ + "static/media/Portrait-10268.324b73da.jpg";